import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { refundViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getRefundViewInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getViewInfo, param);

    if (data.data === null) {
      yield put(refundViewAction.loadRefundViewSuccess(false));
    } else {
      yield put(refundViewAction.loadRefundViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(refundViewAction.loadRefundViewFail(error));
    yield put(globalFinishLoading());
  }
}
